import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Edit, Trash2 } from "lucide-react";
import { useProdutos, useDeleteProduto } from "@/features/produtos/hooks/useProdutos";

interface ProductTableProps {
  searchTerm: string;
  categoryFilter: string;
  supplierFilter: string;
}

export function ProductTable({ searchTerm }: ProductTableProps) {
  const { produtos, isLoading } = useProdutos();
  const deleteProduto = useDeleteProduto();

  const filtered = produtos.filter((p) =>
    p.descricao.toLowerCase().includes(searchTerm.toLowerCase()) ||
    (p.codigoBarras ?? "").includes(searchTerm) ||
    (p.descricaoReduzida ?? "").toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (isLoading) {
    return (
      <div className="rounded-md border">
        <Table>
          <TableBody>
            <TableRow>
              <TableCell colSpan={5} className="text-center text-muted-foreground py-8">
                Carregando produtos...
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
    );
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Código de Barras</TableHead>
            <TableHead>Produto</TableHead>
            <TableHead>Descrição Reduzida</TableHead>
            <TableHead className="text-right">Preço</TableHead>
            <TableHead className="text-center">Status</TableHead>
            <TableHead className="text-right">Ações</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {filtered.length === 0 ? (
            <TableRow>
              <TableCell colSpan={6} className="text-center text-muted-foreground py-8">
                Nenhum produto encontrado
              </TableCell>
            </TableRow>
          ) : (
            filtered.map((produto) => (
              <TableRow key={produto.id}>
                <TableCell className="font-mono text-sm">{produto.codigoBarras || "-"}</TableCell>
                <TableCell className="font-medium">{produto.descricao}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{produto.descricaoReduzida || "-"}</TableCell>
                <TableCell className="text-right font-medium">
                  {produto.precoPadrao.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                </TableCell>
                <TableCell className="text-center">
                  <Badge variant={produto.inativo ? "secondary" : "default"}>
                    {produto.inativo ? "Inativo" : "Ativo"}
                  </Badge>
                </TableCell>
                <TableCell className="text-right">
                  <div className="flex justify-end gap-2">
                    <Button variant="ghost" size="icon" className="h-8 w-8">
                      <Edit className="h-4 w-4" />
                    </Button>
                    <Button
                      variant="ghost"
                      size="icon"
                      className="h-8 w-8 text-destructive hover:text-destructive"
                      onClick={() => deleteProduto.mutate(String(produto.id))}
                    >
                      <Trash2 className="h-4 w-4" />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
